/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from "@atproto/lex";

const $nsid = "place.stream.branding.getBlob";

export { $nsid };

export const $params = /*#__PURE__*/ l.params({"key":/*#__PURE__*/ l.string(),"broadcaster":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.string({"format":"did"}))});

export type $Params = l.InferOutput<typeof $params>;

export const $output = /*#__PURE__*/ l.payload("*/*");

/** Raw blob data with appropriate content-type */
export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>;
/** Raw blob data with appropriate content-type */
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<typeof $output, B>;

/** Get a specific branding asset blob by key. */
const main = /*#__PURE__*/ l.query($nsid, $params, $output, ["BrandingNotFound"]);

export { main };

export const $lxm = $nsid;
